import React from "react";

const ItemBody5 = ({ notification }) => {
  return (
    <p className="font-poppins text-xs font-light">
      <span className="font-medium text-primary capitalize">
        {notification?.metaData?.supplierHubName}{" "}
      </span>
      has <span className="font-medium text-primary">accepted </span>
      your request of {notification?.metaData?.batteryCount} batteries. Please
      reach the hub station to check-in the batteries.
    </p>
  );
};

export default ItemBody5;
